import React from "react";

const Page = ({ page, handlePageNumber, pageNumber }) => {
  return (
    <li
      className={page === pageNumber ? "active cursor" : "cursor"}
      onClick={() => handlePageNumber(page)}
    >
      {page}
    </li>
  );
};

export default Page;
